export default __webpack_public_path__ + "static/media/chart4.a42307c8.svg";